import type { ReactNode, TdHTMLAttributes, ThHTMLAttributes } from "react";
import { cx } from "./cx";

/**
 * Scrolls sideways on narrow screens instead of squashing columns. `relative` keeps visually hidden labels inside the
 * scroll box; without it they widen the whole page.
 */
export function Table({ children, minWidth = 720, label }: { children: ReactNode; minWidth?: number; label: string }) {
  return (
    <div className="relative overflow-x-auto">
      <table aria-label={label} className="w-full border-collapse [&_tbody_tr]:motion-safe:transition-colors [&_tbody_tr:hover]:bg-paper/50 [&_tbody_tr:last-child_td]:border-b-0" style={{ minWidth }}>{children}</table>
    </div>
  );
}

export function Th({ className, ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return <th scope="col" className={cx("border-b-2 border-ink bg-paper/60 px-4.5 py-3 text-left font-mono text-xs font-medium uppercase tracking-widest text-muted", className)} {...rest} />;
}

export function Td({ className, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cx("border-b border-line px-4.5 py-3 align-middle tabular-nums", className)} {...rest} />;
}

/** Visually hidden but read by screen readers. */
export const SrOnly = ({ children }: { children: ReactNode }) => <span className="sr-only">{children}</span>;
